import { useMemo, type ReactElement } from 'react'
import { useCartContext } from '../shared/useCartContext'
import { dayjs } from '@stuller/shared/util/core'
import { useCartItemContext } from './context/useCartItemContext'

/**
 * Show the creation date of the cart item
 */
function CartItemCreationDate (): ReactElement {
  const { cartArea } = useCartContext()
  const { cartLine } = useCartItemContext()

  const creationDateTitle = useMemo(() => {
    const formattedCreationDate = dayjs(cartLine.creationDate).format('l')

    if (cartArea === 'saved-items-page') {
      return `Saved for later on ${formattedCreationDate}`
    }
    if (cartArea === 'jeweler-showcase-carts-page') {
      return `Requested on ${formattedCreationDate}`
    }

    return `Added to cart on ${formattedCreationDate}`
  }, [cartLine.creationDate, cartArea])

  return (
    <p className='mb-2 mb-xl-0 fs-6'>{creationDateTitle}</p>
  )
}

export {
  CartItemCreationDate
}
